import { usePanorama } from '@wix/yoshi-flow-editor';
import {
  getCurrencyFormatter,
  getDateFormatter,
  getTimeFormatter,
} from '../lib/formatters/get-formatters';
import { useSearchEnvironment } from './useSearchEnvironment';

export const useFormatters = () => {
  const { locale } = useSearchEnvironment();
  const panoramaClient = usePanorama();

  return {
    formatCurrency: getCurrencyFormatter(locale, panoramaClient),
    formatDate: getDateFormatter(locale, panoramaClient),
    formatTime: getTimeFormatter(locale, panoramaClient),
  };
};
